import styled from 'styled-components';

export const BlockStyles = styled.div`
    span {
        font-size: 13px;
        align-items: end;
    }
`;

export const Container = styled.div`
    .colorPurple {
        color: var(--purple);
    }

    .colorPink {
        color: var(--pink);
    }

    .color-green {
        color: var(--green);
    }

    .color-yellow {
        color: var(--yellow);
    }

    .color-purple {
        color: var(--purple);
    }

    .color-red {
        color: var(--red);
    }

    .color-blue {
        color: var(--blue);
    }

    .color-white {
        color: var(--white);
    }

    .color-brown {
        color: var(-brown);
    }
`;
